import React from 'react'
import { useCasevoStore } from '../../store/useCasevoStore'
import { VIEWING_PANE_HEADINGS } from '../../constants/viewingPane.constants'
import { ViewingPaneToggles } from '../../types/case.types'
import { useCanViewCaseHistory } from '../../hooks/useCanViewCaseHistory'
interface HeadingTogglePanelProps {
  isOpen: boolean
  onClose: () => void
}
const HeadingTogglePanel: React.FC<HeadingTogglePanelProps> = ({ isOpen, onClose }) => {
  const { viewingPaneToggles, toggleHeading, userRole } = useCasevoStore()
  // Mirror ViewingPane's History gate — hide the History toggle for
  // viewers the firm's case-history-visibility setting excludes, so the
  // section can't be toggled back on (it wouldn't render anyway).
  const canViewCaseHistory = useCanViewCaseHistory()
  if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="flex-1 bg-black bg-opacity-30" onClick={onClose} />
      <div className="w-72 bg-casevo-surface border-l border-casevo-border flex flex-col h-full">
        <div className="flex justify-between items-center px-4 py-4 border-b border-casevo-border">
          <span className="text-xs uppercase tracking-widest text-casevo-brand font-normal">
            Sections
          </span>
          <button type="button" onClick={onClose} aria-label="Close sections panel" className="text-casevo-mid hover:text-casevo-forest text-sm">
            ✕
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-4 py-4">
          {VIEWING_PANE_HEADINGS.map((heading) => {
            if (heading.adminOnly && userRole !== 'admin') return null
            if (heading.key === 'history' && !canViewCaseHistory) return null
            return (
              <div key={heading.key} className="flex justify-between items-center py-3 border-b border-casevo-border last:border-0">
                <span className="text-sm text-casevo-forest">
                  {heading.label}
                  {heading.adminOnly && (
                    <span className="ml-2 text-xs text-casevo-mid">Admin</span>
                  )}
                </span>
                <button
                  onClick={() => toggleHeading(heading.key as keyof ViewingPaneToggles)}
                  className={`w-10 h-6 rounded-full transition-colors relative ${
                    viewingPaneToggles[heading.key as keyof ViewingPaneToggles]
                      ? 'bg-casevo-brand'
                      : 'bg-casevo-border'
                  }`}
                >
                  <span
                    className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform ${
                      viewingPaneToggles[heading.key as keyof ViewingPaneToggles]
                        ? 'translate-x-4'
                        : 'translate-x-0'
                    }`}
                  />
                </button>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
export default HeadingTogglePanel
